import axios from 'axios';
import { toast } from 'react-toastify';
import { history } from "./global-router";

const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL, // our API base URL,
    // rejectUnauthorized: false,
});
// api.defaults.baseURL = process.env.REACT_APP_NOT_SECRET_CODE;
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('auth-token'); // Assuming you store the token in localStorage
        if (token) {
            config.headers["auth-header"] = token;
        }
        return config;
    },
    (error) => {
        alert("Unable to complete the request")
        return Promise.reject(error);
    }
);

api.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response.status == 403) {
        toast.error("Unauthorised user.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            type: "warning"
        });
        history.push('/login');
    } else {
        toast.error("Unable to complete the request.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            type: "error"
        });
    }

    return Promise.reject(error);
});

export default api;